<template>
  <b-container>
    <b-row id="login" align-v="center">
      <b-col>
        <b-row class="d-flex justify-content-center">
          <b-col class="d-flex justify-content-center" cols="6">
            <img src="@/assets/logo.png" class="logo">
          </b-col>
        </b-row>

        <b-row class="d-flex justify-content-center mt-5">
          <b-col class="d-flex justify-content-center" cols="4">
            <b-button @click="googleAuth" block variant="primary">Continue with Google</b-button>
          </b-col>
        </b-row>

        <b-row class="d-flex justify-content-center mt-2">
          <b-col class="d-flex justify-content-center" cols="4">
            <b-alert show variant="danger" v-if="alert">{{alert}}</b-alert>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'login',
  data(){
    return{
      alert:false
    }
  },
  methods:{
    googleAuth(){
      let provider = new firebase.auth.GoogleAuthProvider();
      let user = null;

      firebase.auth()
      .signInWithPopup(provider)
      .then((result)=>{
        user = result.user;
        return firebase.firestore().collection("users").doc(user.uid).get()
      })
      .then((docSnapshot)=>{
        if(!docSnapshot.exists){
          return firebase.firestore()
          .collection('users').doc(user.uid).set({
            date:new Date(),
            lastLogin:new Date(),
            displayName:user.displayName,
            companies:[],
          })
        }else{
          return firebase.firestore()
          .collection('users').doc(user.uid).set({
            lastLogin:new Date(),
          },{merge: true})
        }
      })
      .then(()=>{
        this.$router.replace({name:'dashboard'})
      }).catch((error)=>{
        this.alert = error.message;
      });
    },
  },
}
</script>

<style scoped>
#login{
  min-height: 100vh;
}
</style>